import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { CustomCard } from 'components/CustomCard';
import { Stream } from 'components/Stream';
import { styleSheet } from './stylesheet';

const COMPONENT_MAP = {
    custom: CustomCard
};

class CustomStream extends PureComponent {
    static propTypes = {
        dashboardId: PropTypes.string.isRequired,
        loadMoreMatches: PropTypes.func,
        loading: PropTypes.bool,
        matches: PropTypes.arrayOf(PropTypes.object),
        passedStyles: PropTypes.objectOf(PropTypes.any),
        streamId: PropTypes.string,
        streamProps: PropTypes.objectOf(PropTypes.any).isRequired,
        styles: PropTypes.objectOf(PropTypes.any).isRequired,
        subtitle: PropTypes.string,
        template: PropTypes.objectOf(PropTypes.any),
        templateType: PropTypes.string
    };

    static defaultProps = {
        loading: false,
        loadMoreMatches: null,
        matches: [],
        passedStyles: {},
        streamId: null,
        subtitle: undefined,
        template: null,
        templateType: null
    };

    render() {
        const {
            dashboardId,
            loadMoreMatches,
            loading,
            matches,
            passedStyles,
            streamId,
            streamProps,
            styles,
            subtitle,
            template,
            templateType
        } = this.props;
        return (
            <Stream
                {...streamProps}
                dashboardId={dashboardId}
                loadMoreMatches={loadMoreMatches}
                loading={loading}
                offset={matches.length}
                streamId={streamId}
                styles={{ ...styles.container, ...passedStyles }}
                subtitle={subtitle}
            >
                {matches.map(m => {
                    const CardComponent = COMPONENT_MAP[m.type];
                    return (
                        <CardComponent
                            streamId={streamId}
                            key={`custom-card-${m.id}`}
                            template={template}
                            templateType={templateType}
                            {...m}
                        />
                    );
                })}
            </Stream>
        );
    }
}

export const CustomStreamUI = compose(withStyleSheet(styleSheet))(CustomStream);
